export default __webpack_public_path__ + "static/media/276.504bf0c8.png";